<script lang="ts">
    import {verbs} from './verbs'
    import ListItem from '$lib/components/word-list/list-item.svelte';
    import CtaDividers from '$lib/components/word-list/cta-dividers.svelte';
    import {buildJsonLd} from '$lib/utils/build-json-ld';
    import EndBlock from '$lib/components/word-list/EndBlock.svelte';
</script>

<svelte:head>
    <title>100 Most Common German Verbs | Master German Vocabulary</title>
    <meta name="description"
          content="Expand your German vocabulary with ease! Discover the 100 most common German verbs and enhance your language skills today.">

    {@html `<script type="application/ld+json">${buildJsonLd('100 Most Common German Verbs', verbs)}</script>`}
</svelte:head>

<div class="word-list-article card">
    <h1>
        100 Most Common German Verbs (with example sentences)
    </h1>
    <p>
        If you're learning the German language, mastering the most common German verbs is one of the smartest steps you
        can take. Verbs are the backbone of every sentence, and knowing the top 100 will give you the tools to express
        yourself in everyday situations—from saying what you <em>think</em>, to what you <em>need</em>, to how you <em>feel</em>.
    </p>
    <p>
        In this guide, we've compiled a list of the most frequently used German verbs, complete with English meanings
        and example sentences to help you learn them in context. Whether you're a beginner or brushing up your skills,
        these essential verbs will boost your vocabulary and confidence fast.
    </p>
    <h2>
        Top 100 Essential German Verbs
    </h2>

    <div class="word-list">
        {#each verbs as verb, index}
            <ListItem {...verb}/>
            <CtaDividers
                    numberOfItems={verbs.length}
                    index={index}
            />
        {/each}
    </div>

    <EndBlock
            whatThisPageIsAbout={'the 100 most common German verbs'}
            link1={{url: '100-most-common-german-nouns', text: '100 most common German nouns'}}
            link2={{url: '100-most-common-german-adjectives', text:'100 most common German adjectives'}}
    />
</div>